export default {
  MAX_DAYS_BACK_FOR_CONVERSATIONS: 660,
};
